import React from "react";
import BottomPopup from "./BottomPopup";
import "../../scss/form.scss";
import "../../scss/button.scss";

const DOBPopup = ({ isOpen, dob, onChange, onClose, onConfirm, pageerror }) => {
  return (
    <BottomPopup
      isOpen={isOpen}
      onClose={onClose}
      title="Enter your Date of Birth"
      className="hintText dob-popup"
      hideClose={true}
      buttons={[
        {
          label: "Confirm",
          onClick: onConfirm,
          className: "btn-primary",
          disabled: !dob,
        },
      ]}
    >
      <div className="input-wrapper">
        <input
          type="text"
          inputMode="numeric"
          pattern="\\d{2}/\\d{2}/\\d{4}"
          placeholder=" "
          className="form-control"
          value={dob}
          onChange={(e) => {
            let value = e.target.value.replace(/\D/g, "");

            if (value.length > 8) value = value.slice(0, 8);

            let formattedValue = "";
            if (value.length > 0) {
              formattedValue = value.substring(0, 2);
            }
            if (value.length > 2) {
              formattedValue += "/" + value.substring(2, 4);
            }
            if (value.length > 4) {
              formattedValue += "/" + value.substring(4, 8);
            }

            onChange(formattedValue);
          }}
          onKeyDown={(e) => {
            if (e.key === "Backspace") {
              e.preventDefault();

              const raw = dob.replace(/\D/g, "");
              const newRaw = raw.slice(0, -1);

              let formattedValue = "";
              if (newRaw.length > 0) formattedValue = newRaw.substring(0, 2);
              if (newRaw.length > 2)
                formattedValue += "/" + newRaw.substring(2, 4);
              if (newRaw.length > 4)
                formattedValue += "/" + newRaw.substring(4, 8);

              onChange(formattedValue);
            }
          }}
          maxLength={10}
        />
        <label>DOB (DD/MM/YYYY)</label>
        {pageerror ? (
          <p className="error">{pageerror}</p>
        ) : (
          <p className="hintText">Please double check, it's important</p>
        )}
      </div>
    </BottomPopup>
  );
};

export default DOBPopup;
